import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterParams, StarbaseDataService } from 'starbase-launcher';
import { LU_SubscriptionDiscountModel } from '../models/lu_subscriptiondiscount';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class LuSubscriptionDiscountService extends StarbaseDataService<LU_SubscriptionDiscountModel> {

  protected _staleDataTimeout = 2000;
  protected _getOneUri = '/api/LU_SubscriptionDiscount/';
  protected _getAllUri = '/api/LU_SubscriptionDiscount';
  protected _postUri = '/api/LU_SubscriptionDiscount';
  protected _putUri = '/api/LU_SubscriptionDiscount/';
  protected _deleteUri = '/api/LU_SubscriptionDiscount/';
  protected _broadSearchUri: string;
  private _getByCodeUri = '/api/LU_SubscriptionDiscount/GetDiscountByCode?code=';

  constructor(_http: HttpClient, _webApi: WebApiService) {
    super(_http, _webApi);
   }

  public putData(url: string, id: string, changedObject: LU_SubscriptionDiscountModel): Observable<LU_SubscriptionDiscountModel> {
    changedObject.subscriptionPriceUID = changedObject.subscriptionPrice.uid;
    changedObject.subscriptionPrice = null;
    return super.putData(url, id, changedObject);
  }

  public postData(url: string, postObject: LU_SubscriptionDiscountModel): Observable<LU_SubscriptionDiscountModel> {
    postObject.subscriptionPriceUID = postObject.subscriptionPrice.uid;
    postObject.subscriptionPrice = null;
    return super.postData(url, postObject);
  }

  public getDiscountByCode(code: string, planId: number): Observable<LU_SubscriptionDiscountModel> {
    return this.getData(this._getByCodeUri, encodeURIComponent(code) + '&planId=' + planId, 0);
  }

}
